import "jquery";
// import { gsap } from "gsap";

export const waitForFinalEvent = (function () {
  const timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
    if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

const debounce = (func, wait = 1000) => {
  let timerId;
  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func.apply(null, args);
    }, wait);
  };
};

export function initScrollAnimation() {
  const colors = [
    { r: 255, g: 82, b: 202 },
    { r: 196, g: 17, b: 239 },
    { r: 0, g: 190, b: 153 },
  ];
  // const windowHeight = $(window).height();
  const bodyHeight = $("body").outerHeight();
  const targetHeight = bodyHeight;
  function setTextColor() {
    const scrollTop = $(window).scrollTop();
    const ratio = scrollTop / targetHeight
    const indexRaw = ratio * colors.length
    const index = Math.floor(indexRaw)
    const indexRatio = indexRaw - index;
    let color = {};
    if (ratio === 0) {
      color = colors[0];
    } else if (index >= colors.length - 1) {
      color = colors[colors.length - 1];
    } else {
      const colorStart = colors[index];
      const colorEnd = colors[index + 1];
      color = {
        r: colorStart.r + (Math.floor(colorEnd.r - colorStart.r) * indexRatio),
        g: colorStart.g + (Math.floor(colorEnd.g - colorStart.g) * indexRatio),
        b: colorStart.b + (Math.floor(colorEnd.b - colorStart.b) * indexRatio),
      }
    }
    const root = document.documentElement;
    root.style.setProperty('--apt-color-text-primary', `rgb(${color.r}, ${color.g}, ${color.b})`);
  }

  document.addEventListener('scroll', debounce(setTextColor, 400), {passive: true});
  setTextColor();
}
